import { useQuery } from '@tanstack/react-query';
import {
  LinearOptimizationsLambdaFetch,
  StreamingOptimizationsLambdaFetch,
  awaitJSON
} from '@src/utils/fetch-utils';
import {
  ConstraintDiagnostics,
  ConstraintDiagnosticsTarget,
  INFEASIBLE_RUN_STATUS
} from './constraint-diagnostics-constants';

// Mounted only when run details are opened; never fetch every row's report in the run list.
export const useConstraintDiagnostics = (target: ConstraintDiagnosticsTarget) =>
  useQuery({
    queryKey: [
      'constraintDiagnostics',
      target.type,
      target.type === 'streaming' ? target.streamingType : null,
      target.company,
      target.kpi,
      target.runId
    ],
    queryFn: async () => {
      const result =
        target.type === 'linear'
          ? await LinearOptimizationsLambdaFetch('/optimizations', {
              params: { kpi: target.kpi, runId: target.runId, diagnostics: true }
            })
          : await StreamingOptimizationsLambdaFetch('/optimizations', {
              params: {
                company: target.company,
                runId: target.runId,
                streamingType: target.streamingType,
                diagnostics: true
              }
            });
      return awaitJSON<ConstraintDiagnostics>(result);
    },
    enabled:
      target.status === INFEASIBLE_RUN_STATUS &&
      Boolean(target.company && target.kpi && target.runId),
    staleTime: 0,
    refetchOnMount: true,
    retry: false,
    meta: { suppressGlobalError: true }
  });
